var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.75.25a.857.857 0 0 1 .193.916L15.372 23.45a.857.857 0 0 1-1.58.047l-3.585-7.886 5.273-5.275a1.286 1.286 0 0 0-1.817-1.817l-5.275 5.273L.502 10.21A.857.857 0 0 1 .55 8.628L22.836.057a.857.857 0 0 1 .914.193z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamline);
export default __webpack_public_path__ + "static/media/streamline.e0ad932f235757593da5d3041460ac1c.svg";
export { ForwardRef as ReactComponent };